import { useEffect } from "react";
import { Redirect, Route, useParams } from "react-router-dom";

import { useIsSignupEditMode } from "Signups/stateHooks";

export default function AutoNavigateToLastTab({
  signupListID,
  forceToAddItem = false,
  isAdminOfAnyGroup,
}) {
  const { signupTab: currentTab } = useParams();
  const { isSignupEditMode } = useIsSignupEditMode();

  useEffect(() => {
    if (currentTab) localStorage.setItem("signupsLastTab", currentTab);
  }, [currentTab]);

  // This was causing a bug where refreshing while viewing an existing signup would always redirect to the /items tab
  // Keeping commented in case it causes worse regressions
  // if (!isSignupEditMode && currentTab && currentTab !== "items")
  //   return <Redirect to={`/signups/${signupListID}/items`} />;

  if (
    !isAdminOfAnyGroup &&
    currentTab &&
    (currentTab === "respondents" || currentTab === "fundit")
  ) {
    return <Redirect to={`/signups/${signupListID}/items`} />;}

  return (
    <Route exact path={"/signups/" + signupListID}>
      <Redirect
        to={
          "/signups/" +
          signupListID +
          "/" +
          (!forceToAddItem &&
          // isSignupEditMode &&
          localStorage.getItem("signupsLastTab")
            ? localStorage.getItem("signupsLastTab")
            : "items")
        }
      />
    </Route>
  );
}
